// @ts-nocheck
import { Percent, CurrencyUSD, Time, GraphQLDecimal } from '@/graphql/scalars';
import * as Types from '../../../../types/schema';
import { gql } from '@apollo/client';
export type BalanceSheetTable_BalanceSheetRowValueFragment = {
  __typename?: 'BalanceSheetRowValue';
  columnID: string;
  value: CurrencyUSD;
  secondaryValue?: CurrencyUSD | null;
  secondaryValueDescription?: string | null;
  supportsCashValue?: boolean | null;
};
export type BalanceSheetTable_BalanceSheetRowFragment = {
  __typename?: 'BalanceSheetRow';
  ID: string;
  display: string;
  description?: string | null;
  type: Types.BalanceSheetRowType;
  values: Array<({
    __typename?: 'BalanceSheetRowValue';
  } & BalanceSheetTable_BalanceSheetRowValueFragment)>;
  associatedNodes?: Array<{
    __typename?: 'AISuggestion';
  } | {
    __typename?: 'AISuggestionEvidence';
  } | {
    __typename?: 'AccessAgeParameter';
  } | {
    __typename?: 'AccessParameter';
  } | {
    __typename?: 'Account';
  } | {
    __typename?: 'ActiveEstateInsightsPage';
  } | {
    __typename?: 'Activity';
  } | {
    __typename?: 'Address';
  } | {
    __typename?: 'Answer';
  } | {
    __typename?: 'AnswerEvidence';
  } | {
    __typename?: 'AnswerRevision';
  } | {
    __typename?: 'Approval';
  } | {
    __typename?: 'AssetClass';
  } | {
    __typename?: 'AssetGroup';
  } | {
    __typename?: 'AssetStatic';
  } | {
    __typename?: 'AssetV2';
  } | {
    __typename?: 'AssetValuationV2';
  } | {
    __typename?: 'AssetValueV2';
  } | {
    __typename?: 'AsyncJob';
  } | {
    __typename?: 'BalanceSheetBundleConfiguration';
  } | {
    __typename?: 'BalanceSheetCategory';
  } | {
    __typename?: 'BalanceSheetViewConfiguration';
  } | {
    __typename?: 'BeneficiariesBundleConfiguration';
  } | {
    __typename?: 'BeneficiariesTemplateBundleConfiguration';
  } | {
    __typename?: 'Beneficiary';
  } | {
    __typename?: 'BeneficiaryAccessParameter';
  } | {
    __typename?: 'BeneficiaryDesignationGroup';
  } | {
    __typename?: 'BeneficiaryDistribution';
  } | {
    __typename?: 'BeneficiaryDistributionParameter';
  } | {
    __typename?: 'BeneficiaryPage';
  } | {
    __typename?: 'BeneficiaryPowerOfAppointment';
  } | {
    __typename?: 'CCorpBusinessEntity';
  } | {
    __typename?: 'CLTProposal';
  } | {
    __typename?: 'CLTTrust';
  } | {
    __typename?: 'CRTProposal';
  } | {
    __typename?: 'CRTTrust';
  } | {
    __typename?: 'Capability';
  } | {
    __typename?: 'Cashflow';
  } | {
    __typename?: 'ClientOrganization';
  } | {
    __typename?: 'ClientPresentationV2';
  } | {
    __typename?: 'ClientProfile';
  } | {
    __typename?: 'ClientProfileRelationship';
  } | {
    __typename?: 'Collaborator';
  } | {
    __typename?: 'ComparedWaterfall';
  } | {
    __typename?: 'CompletedEstateInsightsPage';
  } | {
    __typename?: 'ControllingParty';
  } | {
    __typename?: 'Conversation';
  } | {
    __typename?: 'CoverPageConfiguration';
  } | {
    __typename?: 'CustodialPersonalAccount';
  } | {
    __typename?: 'DSUEPortability';
  } | {
    __typename?: 'DiagramArtifact';
  } | {
    __typename?: 'DiagramArtifactPrompt';
  } | {
    __typename?: 'DispositionScenario';
  } | {
    __typename?: 'DispositiveProvision';
  } | {
    __typename?: 'DispositiveProvisionTemplate';
  } | {
    __typename?: 'DividerBundleConfiguration';
  } | {
    __typename?: 'DividerTemplateBundleConfiguration';
  } | {
    __typename?: 'Document';
  } | {
    __typename?: 'DocumentQuestion';
  } | {
    __typename?: 'DocumentQuestionAnswers';
  } | {
    __typename?: 'DocumentSummary';
  } | {
    __typename?: 'DocumentSummaryPage';
  } | {
    __typename?: 'DocumentSummaryPrompt';
  } | {
    __typename?: 'DocumentSummaryPromptTestRun';
  } | {
    __typename?: 'DocumentSummaryTemplateBundleConfiguration';
  } | {
    __typename?: 'DonorAdvisedFund';
  } | {
    __typename?: 'Employee';
  } | {
    __typename?: 'EntitiesOverviewBundleConfiguration';
  } | {
    __typename?: 'EntitiesOverviewBundleConfigurationEntity';
  } | {
    __typename?: 'Entity';
    id: string;
  } | {
    __typename?: 'EntityDiagram';
  } | {
    __typename?: 'EntityDocumentRelationship';
  } | {
    __typename?: 'EntityGraphView';
  } | {
    __typename?: 'EntityGraphViewBundleConfiguration';
  } | {
    __typename?: 'EntityNotes';
  } | {
    __typename?: 'EntityProposal';
  } | {
    __typename?: 'EntitySummaryBundleConfiguration';
  } | {
    __typename?: 'EntitySummaryTemplateBundleConfiguration';
  } | {
    __typename?: 'EntityTask';
  } | {
    __typename?: 'EntityTaxInfo';
  } | {
    __typename?: 'EstateInsight';
  } | {
    __typename?: 'EstateInsightReference';
  } | {
    __typename?: 'EstateInsightsBundleConfiguration';
  } | {
    __typename?: 'EstateTaxScenario';
  } | {
    __typename?: 'EstateWaterfall';
  } | {
    __typename?: 'EstateWaterfallHypotheticalStateChange';
  } | {
    __typename?: 'EstateWaterfallHypotheticalTransfer';
  } | {
    __typename?: 'EstateWaterfallMessageContext';
  } | {
    __typename?: 'EstateWaterfallVisualizationConfig';
  } | {
    __typename?: 'EstateWaterfallVisualizationFilter';
  } | {
    __typename?: 'FamilyTreeBundleConfiguration';
  } | {
    __typename?: 'FamilyTreeConfiguration';
  } | {
    __typename?: 'FeatureFlag';
  } | {
    __typename?: 'FeatureFlagQueryRule';
  } | {
    __typename?: 'File';
  } | {
    __typename?: 'FilePage';
  } | {
    __typename?: 'FileParagraph';
  } | {
    __typename?: 'Form';
  } | {
    __typename?: 'FormVersion';
  } | {
    __typename?: 'GPBusinessEntity';
  } | {
    __typename?: 'GRATAnnuityV2';
  } | {
    __typename?: 'GRATProposalScenario';
  } | {
    __typename?: 'GRATTrust';
  } | {
    __typename?: 'GiftingProposal';
  } | {
    __typename?: 'GiftingProposalCashFlow';
  } | {
    __typename?: 'GiftingProposalGift';
  } | {
    __typename?: 'GiftingProposalGiftSender';
  } | {
    __typename?: 'GiftingProposalPortfolio';
  } | {
    __typename?: 'GiftingProposalScenario';
  } | {
    __typename?: 'GraphVisualizationGroup';
  } | {
    __typename?: 'GrowthProfile';
  } | {
    __typename?: 'GrowthProfileOverride';
  } | {
    __typename?: 'Household';
  } | {
    __typename?: 'HypotheticalCLT';
  } | {
    __typename?: 'HypotheticalCRT';
  } | {
    __typename?: 'HypotheticalGRAT';
  } | {
    __typename?: 'HypotheticalInsurance';
  } | {
    __typename?: 'HypotheticalSaleLoan';
  } | {
    __typename?: 'HypotheticalTransferAsset';
  } | {
    __typename?: 'HypotheticalTransferFundingSource';
  } | {
    __typename?: 'HypotheticalWaterfallDispositiveProvisionTemplate';
  } | {
    __typename?: 'ILITCrummeyLetter';
  } | {
    __typename?: 'ILITTrust';
  } | {
    __typename?: 'Image';
  } | {
    __typename?: 'IncomeTaxPaymentConfig';
  } | {
    __typename?: 'IndividualPersonalAccount';
  } | {
    __typename?: 'InferredField';
  } | {
    __typename?: 'InferredFieldEvidence';
  } | {
    __typename?: 'InsightsTemplateBundleConfiguration';
  } | {
    __typename?: 'InsurancePersonalAccount';
  } | {
    __typename?: 'InsurancePolicy';
  } | {
    __typename?: 'InsurancePremiumPayment';
  } | {
    __typename?: 'IntegrationAssetClass';
  } | {
    __typename?: 'IntegrationCashflow';
  } | {
    __typename?: 'IntegrationClient';
  } | {
    __typename?: 'IntegrationConfiguration';
  } | {
    __typename?: 'IntegrationEntity';
  } | {
    __typename?: 'IntegrationInsurance';
  } | {
    __typename?: 'IntegrationLiability';
  } | {
    __typename?: 'IntegrationPerson';
  } | {
    __typename?: 'IrrevocableTrust';
  } | {
    __typename?: 'JointPersonalAccount';
  } | {
    __typename?: 'KGNode';
  } | {
    __typename?: 'KGRelationship';
  } | {
    __typename?: 'KGRoot';
  } | {
    __typename?: 'KGV2Document';
  } | {
    __typename?: 'KGV2DocumentChange';
  } | {
    __typename?: 'KGV2DocumentModification';
  } | {
    __typename?: 'KGV2Graph';
  } | {
    __typename?: 'KGV2Node';
  } | {
    __typename?: 'KGV2NodeAlias';
  } | {
    __typename?: 'KGV2NodeEvidence';
  } | {
    __typename?: 'KGV2Statement';
  } | {
    __typename?: 'KGV2StatementEvidence';
  } | {
    __typename?: 'KGV2StatementSupersession';
  } | {
    __typename?: 'KeyPerson';
  } | {
    __typename?: 'KeyPersonRole';
  } | {
    __typename?: 'LLCBusinessEntity';
  } | {
    __typename?: 'LPBusinessEntity';
  } | {
    __typename?: 'LiabilitiesBundleConfiguration';
  } | {
    __typename?: 'Liability';
    id: string;
  } | {
    __typename?: 'LiabilityPayment';
  } | {
    __typename?: 'LifeInsuranceBundleConfiguration';
  } | {
    __typename?: 'LifetimeExclusionEvent';
  } | {
    __typename?: 'LoggedTransfer';
  } | {
    __typename?: 'LuminaryOrganization';
  } | {
    __typename?: 'LuminaryTenantJIT';
  } | {
    __typename?: 'ManagedSFTPConnection';
  } | {
    __typename?: 'Memo';
  } | {
    __typename?: 'MemoPrompt';
  } | {
    __typename?: 'Message';
  } | {
    __typename?: 'MissingDocumentOverride';
  } | {
    __typename?: 'MissingDocumentsPage';
  } | {
    __typename?: 'ModelMapping';
  } | {
    __typename?: 'NotificationApp';
  } | {
    __typename?: 'NotificationPreference';
  } | {
    __typename?: 'OpenaiSdkConfig';
  } | {
    __typename?: 'OrganizationApplicationConfiguration';
  } | {
    __typename?: 'OrganizationDisclaimerConfiguration';
  } | {
    __typename?: 'OwnershipStake';
  } | {
    __typename?: 'PlatformDocument';
  } | {
    __typename?: 'PlatformFile';
  } | {
    __typename?: 'PlatformFilePage';
  } | {
    __typename?: 'PlatformFileParagraph';
  } | {
    __typename?: 'PresentationApprovalRequest';
  } | {
    __typename?: 'PresentationAssetDistributionBundleConfiguration';
  } | {
    __typename?: 'PresentationAssetDistributionItemConfiguration';
  } | {
    __typename?: 'PresentationAssetDistributionItemDetail';
  } | {
    __typename?: 'PresentationBundle';
  } | {
    __typename?: 'PresentationBundleCoverPage';
  } | {
    __typename?: 'PresentationBusinessOverviewBundleConfiguration';
  } | {
    __typename?: 'PresentationBusinessOverviewBusinessConfiguration';
  } | {
    __typename?: 'PresentationBusinessOverviewItem';
  } | {
    __typename?: 'PresentationCoverPage';
  } | {
    __typename?: 'PresentationCoverSlideConfig';
  } | {
    __typename?: 'PresentationCustomPage';
  } | {
    __typename?: 'PresentationCustomPageBundleConfiguration';
  } | {
    __typename?: 'PresentationDiagramPage';
  } | {
    __typename?: 'PresentationDocumentsReviewedBundleConfiguration';
  } | {
    __typename?: 'PresentationDocumentsReviewedDocument';
  } | {
    __typename?: 'PresentationFamilyOverviewBundleConfiguration';
  } | {
    __typename?: 'PresentationFamilyOverviewMemberConfiguration';
  } | {
    __typename?: 'PresentationHealthcareDirectiveBundleConfiguration';
  } | {
    __typename?: 'PresentationHealthcareDirectiveClientConfiguration';
  } | {
    __typename?: 'PresentationHealthcareDirectiveItem';
  } | {
    __typename?: 'PresentationItemCitation';
  } | {
    __typename?: 'PresentationPage';
  } | {
    __typename?: 'PresentationPlanningOpportunitiesBundleConfiguration';
  } | {
    __typename?: 'PresentationPlanningOpportunitiesItem';
  } | {
    __typename?: 'PresentationPowerOfAttorneyBundleConfiguration';
  } | {
    __typename?: 'PresentationPowerOfAttorneyClientConfiguration';
  } | {
    __typename?: 'PresentationPowerOfAttorneyItem';
  } | {
    __typename?: 'PresentationTemplate';
  } | {
    __typename?: 'PresentationTemplateBundle';
  } | {
    __typename?: 'PresentationTemplateCoverPage';
  } | {
    __typename?: 'PresentationTemplateCustomPage';
  } | {
    __typename?: 'PresentationTemplateDiagramPage';
  } | {
    __typename?: 'PresentationTemplatePage';
  } | {
    __typename?: 'PresentationTrustOverviewBundleConfiguration';
  } | {
    __typename?: 'PresentationTrustOverviewItem';
  } | {
    __typename?: 'PresentationTrustOverviewTrustConfiguration';
  } | {
    __typename?: 'PresentationWillBundleConfiguration';
  } | {
    __typename?: 'PresentationWillClientConfiguration';
  } | {
    __typename?: 'PresentationWillItem';
  } | {
    __typename?: 'Principal';
  } | {
    __typename?: 'PrivateFoundation';
  } | {
    __typename?: 'ProfessionalTeamRole';
  } | {
    __typename?: 'Proposal';
  } | {
    __typename?: 'ProposalScenario';
  } | {
    __typename?: 'QPRTTrust';
  } | {
    __typename?: 'QualifiedTuitionPersonalAccount';
  } | {
    __typename?: 'ReleaseGroup';
  } | {
    __typename?: 'ReminderEmailNotificationRecord';
  } | {
    __typename?: 'RetirementPersonalAccount';
  } | {
    __typename?: 'RevocableTrust';
  } | {
    __typename?: 'Role';
  } | {
    __typename?: 'SCorpBusinessEntity';
  } | {
    __typename?: 'SLATTrust';
  } | {
    __typename?: 'SSOConnection';
  } | {
    __typename?: 'SalesforceExportAttempt';
  } | {
    __typename?: 'ScheduledDistribution';
  } | {
    __typename?: 'SoleProprietorshipBusinessEntity';
  } | {
    __typename?: 'SubBrand';
  } | {
    __typename?: 'SubBrandDisclaimerConfiguration';
  } | {
    __typename?: 'Submission';
  } | {
    __typename?: 'TaxDragConfig';
  } | {
    __typename?: 'TaxDragOverride';
  } | {
    __typename?: 'Team';
  } | {
    __typename?: 'Tenant';
  } | {
    __typename?: 'TenantApplicationConfiguration';
  } | {
    __typename?: 'TenantBranding';
  } | {
    __typename?: 'TenantDisclaimerConfiguration';
  } | {
    __typename?: 'TenantDocument';
  } | {
    __typename?: 'TenantReminderEmailsConfiguration';
  } | {
    __typename?: 'TenantSSOConnection';
  } | {
    __typename?: 'TenantSecurityConfiguration';
  } | {
    __typename?: 'TenantSlideConfig';
  } | {
    __typename?: 'TestCMKEncryption';
  } | {
    __typename?: 'TestamentaryEntity';
  } | {
    __typename?: 'TrustAdvisor';
  } | {
    __typename?: 'TrustAdvisorRole';
  } | {
    __typename?: 'Trustee';
  } | {
    __typename?: 'TrusteeDuty';
  } | {
    __typename?: 'User';
  } | {
    __typename?: 'UserFeedback';
  } | {
    __typename?: 'UserNotificationConfiguration';
  } | {
    __typename?: 'WaterfallBundleConfiguration';
  } | {
    __typename?: 'WaterfallBundleCoverPage';
  } | {
    __typename?: 'WaterfallComparisonBundleConfiguration';
  } | {
    __typename?: 'WaterfallComparisonTemplateBundleConfiguration';
  } | {
    __typename?: 'WaterfallTemplateBundleConfiguration';
  } | {
    __typename?: 'WorkOSOrganization';
  } | {
    __typename?: 'WorkOSOrganizationDomain';
  } | {
    __typename?: 'WorkflowTracker';
  } | null> | null;
};
export type BalanceSheetTable_BalanceSheetColumnFragment = {
  __typename?: 'BalanceSheetColumn';
  ID: string;
  display: string;
  group: string;
  isHidden: boolean;
  variant?: Types.BalanceSheetColumnVariant | null;
};
export type BalanceSheetTable_BalanceSheetFragment = {
  __typename?: 'BalanceSheet';
  hasNoValues: boolean;
  columnGroups: Array<{
    __typename?: 'BalanceSheetColumnGroup';
    ID: string;
    display: string;
  }>;
  columns: Array<({
    __typename?: 'BalanceSheetColumn';
  } & BalanceSheetTable_BalanceSheetColumnFragment)>;
  rows: Array<({
    __typename?: 'BalanceSheetRow';
    children?: Array<({
      __typename?: 'BalanceSheetRow';
    } & BalanceSheetTable_BalanceSheetRowFragment)> | null;
  } & BalanceSheetTable_BalanceSheetRowFragment)>;
};
export const Operations = {
  Fragment: {
    BalanceSheetTable_BalanceSheetRowValue: 'BalanceSheetTable_BalanceSheetRowValue' as const,
    BalanceSheetTable_BalanceSheetRow: 'BalanceSheetTable_BalanceSheetRow' as const,
    BalanceSheetTable_BalanceSheetColumn: 'BalanceSheetTable_BalanceSheetColumn' as const,
    BalanceSheetTable_BalanceSheet: 'BalanceSheetTable_BalanceSheet' as const
  }
};

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy
    }
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options
  };
}
export const BalanceSheetTable_BalanceSheetColumnFragmentDoc = gql`
    fragment BalanceSheetTable_BalanceSheetColumn on BalanceSheetColumn {
  ID
  display
  group
  isHidden
  variant
}
    `;
export const BalanceSheetTable_BalanceSheetRowValueFragmentDoc = gql`
    fragment BalanceSheetTable_BalanceSheetRowValue on BalanceSheetRowValue {
  columnID
  value
  secondaryValue
  secondaryValueDescription
  supportsCashValue
}
    `;
export const BalanceSheetTable_BalanceSheetRowFragmentDoc = gql`
    fragment BalanceSheetTable_BalanceSheetRow on BalanceSheetRow {
  ID
  display
  description
  type
  values {
    ...BalanceSheetTable_BalanceSheetRowValue
  }
  associatedNodes {
    ... on Entity {
      id
    }
    ... on Liability {
      id
    }
  }
}
    ${BalanceSheetTable_BalanceSheetRowValueFragmentDoc}`;
export const BalanceSheetTable_BalanceSheetFragmentDoc = gql`
    fragment BalanceSheetTable_BalanceSheet on BalanceSheet {
  hasNoValues
  columnGroups {
    ID
    display
  }
  columns {
    ...BalanceSheetTable_BalanceSheetColumn
  }
  rows {
    ...BalanceSheetTable_BalanceSheetRow
    children {
      ...BalanceSheetTable_BalanceSheetRow
    }
  }
}
    ${BalanceSheetTable_BalanceSheetColumnFragmentDoc}
${BalanceSheetTable_BalanceSheetRowFragmentDoc}`;